import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "@/stores/authStore";

export function MagicLinkPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { verifyMagicLink, isAuthenticated, isLoading, error } = useAuthStore();

  useEffect(() => {
    if (isAuthenticated) return; // already logged in — redirect effect handles navigation
    const token = searchParams.get("token");
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    verifyMagicLink(token);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Redirect to app once authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="cx-login-bg flex h-full items-center justify-center">
      <div className="cx-login-card w-full max-w-sm p-8 text-center">
        <h1 className="cx-login-heading mb-1 text-center text-2xl font-bold">Ortvis</h1>

        {!error && (
          <p className="cx-login-subtitle mt-4 text-[14px]" aria-live="polite">
            {isLoading ? t("auth.magicLinkOpening") : t("auth.magicLinkOpening")}
          </p>
        )}

        {error && (
          <>
            <p className="cx-login-error mt-4 rounded-lg p-3 text-[13px]">
              {t("auth.magicLinkExpired")}
            </p>
            <button
              type="button"
              onClick={() => navigate("/login", { replace: true })}
              className="cx-text-accent mt-4 inline-block text-[13px]"
            >
              {t("auth.magicLinkExpiredAction")}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
